import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  background: #DEDEDE;
  border-bottom: 2px solid #fff;
  height: 70px;
  @media (max-width: 540px) {
    overflow-x: scroll;
  }
  a {
    border-left: 1px solid #fff;
    display: flex;
    height: 100%;
    width: 100%;
    min-width: 220px;
    padding: 0 20px;
    text-align: center;
    align-items: center;
    justify-content: center;
    font: 600 16px Montserrat;
    color: #40403F;
    text-decoration: none;
    border-bottom: 4px solid transparent;
    transition: all 0.3s;
    @media (min-width: 540px) {
      &:hover {
        background: #fff;
      }
    }
    &:last-child {
      border-right: 1px solid #fff;
    }
    &.active {
      border-bottom: 4px solid #F1A857;
    }
    i {
      background-size: contain;
      height: 30px;
      width: 30px;
      display: inline-block;
      margin-right: 14px;
    }
  }
`

const IconComiteDeEtica = styled.i`
  background: url(/images/streamline-icon-legal-scale-document@140x140@2x.png) no-repeat center;
`
const IconTrabalheConosco = styled.i`
  background: url(/images/streamline-icon-business-contract-approve@140x140@2x.png) no-repeat center;
`
const IconContato = styled.i`
  background: url(/images/streamline-icon-meeting-headphones-2@140x140@2x.png) no-repeat center;
`

const BarContact = ({active}) => {
  const { language } = useContext(LanguageContext);
  const contato = active === 'contato' ? 'active' : '';
  const trabalheConosco = active === 'trabalhe-conosco' ? 'active' : '';
  let contatoText = ''
  let trabalheText = ''
  let comiteText = ''
  switch (language) {
    case 'pt-br':
      contatoText = 'Entre em contato';
      trabalheText = 'Trabalhe conosco';
      comiteText = 'Comitê de ética';
      break;
    case 'en-us':
      contatoText = 'Contact';
      trabalheText = 'Work with us';
      comiteText = 'Ethics Committee';
      break;
    case 'es-es':
      contatoText = 'Entre en contacto';
      trabalheText = 'Trabaja con nosotros';
      comiteText = 'Comité de Ética';
      break;
    default:
  }
  return (
    <Container>
      <div className="wrapper flex">
        <Link to="/contato" className={ contato }>
          <IconContato />
          { contatoText }
        </Link>
        {
          language === 'pt-br' && (
            <Link to="/contato/trabalhe-conosco" className={ trabalheConosco }>
              <IconTrabalheConosco />
              { trabalheText }
            </Link>
          )
        }
        <a href="https://etica.guararapes.com.br" rel="noopener noreferrer" target="_blank">
          <IconComiteDeEtica />
          { comiteText }
        </a>
      </div>
    </Container>
  )
}

export default BarContact;
